import { Component } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { HandlerService } from '../handler.service';

@Component({
  selector: 'app-ads-org',
  templateUrl: './ads-org.component.html',
  styleUrls: ['./ads-org.component.scss'],
})
export class AdsOrgComponent {
  ads: any = [];
  editId;
  search:any=[];
  loader: boolean = false;
  orgObj: any=[];
  filterLength;
  orgName;
  orgId:any='0';
  change: boolean;
  adsUp:boolean=false;
  mobile:boolean=false;
  adOrgId;
  clicked:boolean=false;
  all:any={name:'All', code:'0',id:'0'};
  constructor(
    public service:ApiService,
    public handler: HandlerService,
    public router: Router,
    public auth: AuthService,
    public bottomSheet: MatBottomSheet,
    public santinizer:DomSanitizer
  ) { }

  ionViewWillEnter() {
    this.loader = true;
    this.clicked=false;
    this.orgObj = JSON.parse(localStorage.getItem('capabilityOrg'));
    this.service.getOrg().subscribe(res => {
      this.orgObj = res;
       this.orgObj.push(this.all);
      this.orgObj.map(res => {
        if (res.id == '0') {
          this.orgName = res.name;
          this.orgId = res.id;
        }
      })
      this.loader = false;
      this.pending();
    }, err => {
      this.handler.err(err);
      this.loader = false;
      this.pending();
    })
   
  }
  selectedId(data) {
    this.editId = data.id;
    localStorage.setItem('dashBoardOrgId',data.orgId)
  }
  editAd() {    
    this.clicked=true;
    this.router.navigate(['/edit-ad', this.editId]);
  }
  previewAd() {
    this.router.navigate(['/about-ad', this.editId]);
  }
  openBottomSheetOrg(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.orgObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.orgName = res.name;
      this.orgId = res.id;
      localStorage.setItem('dashBoardOrgId',res.id)
      if (this.change) {
        this.pending();
      }
      else {
        this.approved();
      }
    });
  }
  pending() {
    this.change = true;
    this.loader = true;
    if(this.orgId=='0'){
      this.service.getAllAds().subscribe((res: any) => {
        if (res && res.length > 0) {
          this.ads = res.filter(res => { return res.status == 2 && res.activeInd});
        }
        else {
          this.ads = [];
        }
        this.loader = false
      }, err => {
        this.handler.err(err);
        this.loader = false;
      })
      
    }
    else{
      this.service.getOrgAds(this.orgId).subscribe((res: any) => {
        if (res && res.length > 0) {
          this.ads = res.filter(res => { return res.status == 2 && res.activeInd});
        }
        else {
          this.ads = [];
        }
        this.loader = false
      }, err => {
        this.handler.err(err);
        this.loader = false;
      })

    }
 

  }
  approved() {
    this.change = false;
    this.loader = true;
    if(this.orgId=='0'){
      this.service.getAllAds().subscribe((res: any) => {
        if (res && res.length > 0) {
          this.ads = res.filter(res => { return res.status == 3 && res.activeInd });
        }
        else {
          this.ads = [];
        }
        this.loader = false
      }, err => {
        this.handler.err(err);
        this.loader = false;
      })

    }
    else{
      this.service.getOrgAds(this.orgId).subscribe((res: any) => {
        if (res && res.length > 0) {
          this.ads = res.filter(res => { return res.status == 3 && res.activeInd });
        }
        else {
          this.ads = [];
        }
        this.loader = false
      }, err => {
        this.handler.err(err);
        this.loader = false;
      })
      
    }
 
  }
  previewDesktopAd() {
    sessionStorage.setItem('desktop', "1");
    this.router.navigate(['/about-ad', this.editId]);
    this.adsUp = false ;
  }
  previewMobileAd() {
    sessionStorage.setItem('desktop', "2");
    this.router.navigate(['/about-ad', this.editId]);
    this.adsUp = false;
  }

  popUp(){
    this.adsUp = true;
    this.mobile = true;
   }
  ionViewWillLeave(){
  if(!this.clicked){
    localStorage.removeItem('dashBoardOrgId');
  }
  this.search = "";
  }

  clear(){
    this.search="";
  }
  ngDoCheck(): void {
    this.filterLength = sessionStorage.getItem('len')
  
  }

}
